import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import selfie from './modules/selfie'
import global from './modules/global'
import image from './modules/image'
import event from './modules/event'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    login,
    selfie,
    global,
    image,
    event
  }
})
